import { Helmet } from "react-helmet-async"
import "../components/Homepage/Homepage.css"

import Instructions from "../components/Referral/Instructions"

export default function Referral() {
	const schema = {
		"@context": "https://schema.org",
		"@type": "WebPage",
		"name": "HRA Administration Software Referral Program | Salusion",
		"description": "Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients.",
		"url": "https://salusion.com/referral-program", // Canonical URL of this page
		"mainEntity": {
			"@type": "Service", // Changed from Organization to Service
			"name": "Salusion Referral Program | Earn $42 Per Participant", // Name of the service
			"description": "Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients.", // Description of the service
			"provider": { // The Organization providing this service
				"@type": "Organization",
				"name": "Salusion, Inc.",
				"url": "https://salusion.com",
				"logo": "https://salusion.com/assets/icons/logos/favicons/mini-logo-152x152.png",
				"sameAs": [
					"https://twitter.com/Salusion", // Your Twitter handle
					"https://linkedin.com/company/salusion-inc" // Your LinkedIn company page
				]
			},
			// The 'offers' array now correctly belongs to the 'Service'
			"offers": [
				{
					"@type": "Offer",
					"name": "Referral Reward",
					"description": "Refer a company and earn up to $42 per participant.",
					"price": "42.00",
					"priceCurrency": "USD",
					"priceSpecification": {
						"@type": "PriceSpecification",
						"maxPrice": "42.00",
					},
					"url": "https://salusion.com/referral-program-signup", // URL to sign up for referral
					"category": "Referral Program",
					"itemOffered": {
						"@type": "Service", // The item offered is a service (participation)
						"name": "Referral Program Participation"
					}
				}
			]
		}
	};
	return (
		<>
			<Helmet>
				<title>HHRA Administration Software Referral Program | Salusion</title>
				<meta name="title" content="HRA Administration Software Referral Program | Salusion" />
				<meta name="description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<link rel="canonical" href="https://salusion.com/referral-program" />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:site" content="@Salusion" />
				<meta name="twitter:title" content="HRA Administration Software Referral Program | Salusion" />
				<meta name="twitter:description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta name="twitter:image" content="https://salusion.com/assets/images/Generic.png" /> <meta name="twitter:image:alt" content="Illustration of a hand offering money to another hand, symbolizing a reward for referrals." />

				<meta property="og:title" content="HRA Administration Software Referral Program | Salusion" />
				<meta property="og:description" content="Join Salusion’s referral program—help small businesses enhance employee benefits and earn up to $42 per referred participant. Easy, rewarding, and ideal for accountants, bookkeepers, and satisfied clients." />
				<meta property="og:image" content="https://salusion.com/assets/images/Generic.png" />
				<meta property="og:url" content="https://salusion.com/referral-program" />
				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Salusion" />
				<meta property="og:locale" content="en_US" />

				<script type="application/ld+json">{JSON.stringify(schema)}</script>

			</Helmet>

			<Instructions />
		</>
	)
}
